import { CSSObject } from '@chakra-ui/react';

export const TextFormInfo: CSSObject = {
  color: 'gamma.200',
  fontWeight: 'medium',
};
